<!-- DATE TIME PICKER COMPONENT-->
<div class="actions-graph">

  <div class="date-time-picker" (onApply)=getDatesFromFilter($event) [configuredPreselectionId]="configuredPreselectionId"  [graphChoicesStepEnabled]="graphChoicesStepEnabled" [updateInfos]="updateInfos"></div>
  <!-- FILTERS -->
  <div class="action-filter__ctn hidden">
    <!-- DISPLAY COLUMN -->
    <div class="displayColumn action-filter">

      <button class="action-filter-btn btn-2" [class.active]="isThreshold" (click)="toggleThresholdMode()">
        <i class="fas fa-arrows-alt-v"></i>
        <span [translate]="'action.threshold_mode'"></span>
      </button>

      @if (showbtnExportRequest) {
        <button class="action-filter-btn btn-2"
          [class.loading]="isLoadingExport"
          (click)="exportData()"
          [class.disabled]="!eUid"
          [disabled]="selectedTagsUid.length == 0 || (selectedTagsUid.length == 1 && selectedTagsUid[0] == undefined)"
          >
          <i class="spinner icon-loader"></i>
          <i class="fas fa-file-download download-icon"></i>
          <span [translate]="'action.requestExport'"></span>
        </button>
      }

    </div>
  </div>
</div>
